
<template>
  <div class="wrapper">
    <div class="messageText">{{message}}</div>
  </div>
</template>

<script>
export default {
  name: 'TopWarning',
  props: ['message']
}
</script>

<style scoped lang='scss'>
@import '../css/var';

.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: red;
  z-index: 100;
  transform: translateY(-100%);

  animation: slideIn .25s 1 forwards;
  @include transition;
}

@keyframes slideIn {
  to {
    transform: translateY(0);
  }
}

.messageText {
  color: white;
  font-weight: 600;
  padding: 20px 20px;
}
</style>